import Projects from "./Projects";
import Map from "./Map";

export default Projects;
export { Map };
